import React from 'react';
import EventEmitter from 'events';

import UserStore from './user_store';

import util from '../tools/util';

export default {
  init,
  useList,
  useKey,
  useApp,
  fetch,
  createApp,
  update,
  newKey,
};

const g_orgListMap = new Map<number, any[]>();
const g_appKeyMap = new Map<number, string>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
function _getKey(app_id: number) {
  return g_appKeyMap.get(app_id);
}
function _getList(org_id: number) {
  return g_orgListMap.get(org_id);
}
export function useList(org_id: number) {
  const _get = React.useCallback(() => _getList(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
export function useApp(org_id: number, app_id: number) {
  const list = useList(org_id);
  return list?.find?.((v) => v.app_id === app_id);
}
export function useKey(app_id: number) {
  const _get = React.useCallback(() => _getKey(app_id), [app_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function init(done?: (err?: any) => void) {
  done?.();
}
export function fetch(org_id: number, done?: (err?: any) => void) {
  const opts = {
    url: `/org_admin/1/org/${org_id}/app`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('app_store.fetch: err:', err);
    } else if (body) {
      const old = g_orgListMap.get(org_id);
      if (!util.deepEqual(old, body.app_list)) {
        g_orgListMap.set(org_id, body.app_list);
        _emit('list');
      }
    }
    done?.(err);
  });
}
export function createApp(params: any, done: (err: any, app_id?: any) => void) {
  const { org_id, app_name } = params;
  const opts = {
    url: `/org_admin/1/org/${org_id}/app`,
    body: { app_name },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('app_store.createApp: err:', err);
      done(err);
    } else {
      fetch(org_id, () => done(null, body.app_id));
    }
  });
}
export function update(params: any, done: (err?: any) => void) {
  const { org_id, app_id, ...other } = params;
  const opts = {
    url: `/org_admin/1/org/${org_id}/app/${app_id}`,
    body: other,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('app_store.update: err:', err);
      done(err);
    } else {
      fetch(org_id, () => done());
    }
  });
}
export function newKey(params: any, done: (err?: any) => void) {
  const { org_id, app_id } = params;
  const opts = {
    url: `/org_admin/1/org/${org_id}/app/${app_id}/new_key`,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('app_store.newKey: err:', err);
      done(err);
    } else {
      g_appKeyMap.set(app_id, body.secret_key);
      fetch(org_id, () => done());
    }
  });
}
